export const environment = {
  production: false,
  apiUrl: 'https://api.admin.balajigames.online/api/'
  // apiUrl: 'https://uat-fcr-admin-api.onrender.com/api/'
  // apiUrl: 'http://admin.api.a2zgame.in/api/'
  // apiUrl: 'https://jackpot-admin-backend.onrender.com/api/'
};
